import React, { useEffect, useState, useCallback } from 'react';
// import BackToServicesButton from '../components/BackToServicesButton';
import API_BASE_URL from '../api';
import { authFetch } from '../authFetch';
import { useAuth } from '../authContext';
import useSelectedRadio from '../hooks/useSelectedRadio';
import { resolveCountryFlag } from "../constants/countries";
import { useTranslation } from 'react-i18next';
import { useLocale, fmtNumber } from '../i18n/format';
import ExportButton from '../components/ExportButton';
import { buildGeoDoc } from "../pdf/builders/geo/buildDoc";
import { buildGeoWorkbook } from "../excel/builders/geo/buildWorkbook";

export default function GeoServicePage() {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [nogeo, setNogeo] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const { radioId, shortcode, name: stationName } = useSelectedRadio();
  const { isAuth } = useAuth();
  const { t } = useTranslation('common');
  const locale = useLocale();

  useEffect(() => {
    if (!startDate || !endDate) {
      const today = new Date().toISOString().slice(0, 10);
      if (!startDate) setStartDate(today);
      if (!endDate) setEndDate(today);
    }
  }, [startDate, endDate]);

  const fetchData = useCallback(() => {
    if (!isAuth || !radioId) return;
    setLoading(true);
    setError('');
    const API = (API_BASE_URL || '').replace(/\/+$/, '');
    let url = `${API}/radios/${encodeURIComponent(radioId)}/metrics/geo/countries`;
    const query = [];
    if (startDate) query.push(`start_date=${startDate}`);
    if (endDate) query.push(`end_date=${endDate}`);
    if (query.length) url += `?${query.join('&')}`;
    authFetch(url)
      .then(r => r.json())
      .then(json => {
        if (!json.data) throw new Error(t('geo.api_error'));
        setData(json.data);
        let totalListeners = 0;
        let noGeoListeners = 0;
        for (const row of json.data) {
          totalListeners += row.listeners;
          if (row.country === 'Без географії') {
            noGeoListeners = row.listeners;
          }
        }
        setTotal(totalListeners);
        setNogeo(noGeoListeners);
      })
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, [isAuth, radioId, startDate, endDate, t]);


  // Загружаем данные только вручную по кнопке

  const onSubmit = e => {
    e.preventDefault();
    fetchData();
  };

  if (!radioId) {
    return (
      <div style={widgetStyle}>
        {/* BackToServicesButton removed */}
        <h2 style={{ marginBottom: 8 }}>{t('geo.title')}</h2>
        <div style={{ color: '#e54848', fontWeight: 600, fontSize: 18 }}>
          {t('geo.no_channel')}
        </div>
      </div>
    );
  }

  return (
    <div style={widgetStyle}>
      {/* BackToServicesButton removed */}
      
      {/* Описание сервиса */}
      <div
        style={{
          width: "100%",
          padding: "8px 12px",
          borderRadius: 8,
          background: "#f8f8f8",
          color: "#1a1a1a",
          fontSize: 17,
          margin: "8px 0 18px 0",
          boxSizing: "border-box"
        }}
      >
        {t('geo.lead')}
      </div>

      <h2 style={{ marginBottom: 8 }}>{t('geo.title')}</h2>
      <div style={{ marginBottom: 16, display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
        <span style={{ fontWeight: 500 }}>📅 {t('geo.from')}</span>
        <input
          type="date"
          value={startDate}
          onChange={e => setStartDate(e.target.value)}
          style={inputStyle}
        />
        <span style={{ fontWeight: 500 }}>📅 {t('geo.to')}</span>
        <input
          type="date"
          value={endDate}
          onChange={e => setEndDate(e.target.value)}
          style={inputStyle}
        />
        <button onClick={onSubmit} style={{ ...showBtn, width: 136 }}>{t('geo.show')}</button>
        <div style={{ display: 'inline-flex', gap: 8, marginLeft:-4 }}>
          <ExportButton
            data={data}
            onBeforeBuild={async () => {
              // подгружаем логотип слева вверху PDF/XLSX
              const url = `${process.env.PUBLIC_URL || ''}/Radiomonitor.NetLogo.png`;
              try {
                const resp = await fetch(url, { cache: 'no-store' });
                const blob = await resp.blob();
                const reader = new FileReader();
                const dataUrl = await new Promise((res, rej) => {
                  reader.onloadend = () => res(reader.result);
                  reader.onerror = rej;
                  reader.readAsDataURL(blob);
                });
                return { logoDataUrl: dataUrl };
              } catch {
                return { logoDataUrl: null };
              }
            }}
            buildDoc={(payload) =>
              buildGeoDoc({
                t, shortcode, stationName,
                serviceName: t('geo.title'),
                startDate, endDate,
                rows: data, total, nogeo,
                fmtNumber, locale,
                logoDataUrl: payload?.logoDataUrl || null
              })
            }
            buildWorkbook={(XLSX, payload) =>
              buildGeoWorkbook(XLSX, {
                t, shortcode, stationName,
                serviceName: t('geo.title'),
                startDate, endDate,
                rows: data, total, nogeo,
                fmtNumber, locale,
                logoDataUrl: payload?.logoDataUrl || null
              })
            }
            filename={`geo_${shortcode}_${startDate}_${endDate}.pdf`}
            xlsxFilename={`geo_${shortcode}_${startDate}_${endDate}.xlsx`}
            label={t('export_pdf')}
            labelXlsx={t('export_excel')}
            style={{
              ...showBtn,
              width: 136,
              background: (!data.length || loading) ? '#9bbdfd' : '#3867fa'
            }}
            disabled={!data.length || loading}
          />
        </div>
      </div>
      {loading && <div style={{ margin: "18px 0", fontWeight: 500 }}>{t('loading')}</div>}
      {error && !loading && <div style={{ color: 'red', fontWeight: 500, margin: "18px 0" }}>{error}</div>}
      {!loading && !error &&
        <>
          <div style={{
            textAlign: 'right',
            fontSize: '1.2em',
            fontWeight: 'bold',
            padding: '0.4em',
            border: '1px solid #333',
            marginBottom: '1em',
            marginTop: '1em',
            borderRadius: 7,
            background: '#fafafa'
          }}>
            {t('geo.total', { count: total, value: fmtNumber(total, locale), total })}
          </div>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 16 }}>
              <thead>
                <tr style={{ background: "#f0f0f0" }}>
                  <th style={thTd}>🌍 {t('geo.table.country')}</th>
                  <th style={{ ...thTd, textAlign: "right" }}>👥 {t('geo.table.listeners')}</th>
                </tr>
              </thead>
              <tbody>
            {data
                  .filter((row) => row.country !== 'Без географії')
                  .map((row) => {
                    const flag = resolveCountryFlag(row);
                    return (
                      <tr key={row.country}>
                        <td style={thTd}>
                          {flag ? (
                            <span>
                              {flag}
                              {" "}
                            </span>
                          ) : null}
                          {row.country}
                        </td>
                        <td style={{ ...thTd, textAlign: 'right' }}>{fmtNumber(row.listeners, locale)}</td>
                      </tr>
                    );
                  })}
                <tr style={{ background: '#f9f9f9', fontWeight: 'bold' }}>
                  <td style={thTd}>🏳️ {t('geo.unknown')}</td>
                  <td style={{ ...thTd, textAlign: 'right' }}>{fmtNumber(nogeo, locale)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      }
    </div>
  );
}

const widgetStyle = {
  maxWidth: 940,
  margin: '40px auto',
  background: '#fff',
  borderRadius: 14,
  padding: 24,
  boxShadow: '0 2px 12px 0 #0001'
};

const inputStyle = {
  marginRight: 8,
  padding: 7,
  borderRadius: 4,
  border: '1px solid #ccc',
  fontSize: 16,
  minWidth: 130
};

const showBtn = {
  background: '#3867fa',
  color: '#fff',
  border: 'none',
  padding: '8px 16px',
  borderRadius: 5,
  fontWeight: 600,
  cursor: 'pointer'
};

const thTd = {
  padding: "7px 12px",
  border: "1px solid #e0e0e0",
  textAlign: "left",
  verticalAlign: "top"
};
